import z from 'zod';

export const vin = z.string().length(17, 'vinError');
